import type { FC } from 'react';
import { NavLink } from 'react-router-dom';
import navData from '../data/navigation/navs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

interface NavMenuProps {
  className?: string;
}

const NavMenu: FC<NavMenuProps> = ({ className = undefined }) => {
  const isAuth = useSelector((state: RootState) => state.isAuth.isAuth);
  const { t } = useTranslation();

  const navBlock = navData?.map((item) => {
    const { id, link, Icon, name, className } = item;
    return (
      (link !== '/profile' || isAuth) && (
        <li key={id} className={className}>
          <NavLink to={link} className={({ isActive }) => (isActive ? 'activeNav' : 'undefined')}>
            {<Icon />}
            <span>{t(name)}</span>
          </NavLink>
        </li>
      )
    );
  });
  return (
    <nav className={`navigation ${className}`}>
      <ul>{navBlock}</ul>
    </nav>
  );
};

export default NavMenu;
